import React from "react";
import Header from "../../components/Header"; 
import Footer from "../../components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import ManageRight from "../Layouts/ManageRight";



export default function ManageAddress() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <ManageRight />

       </div>
      </div>

 
      <Footer />
    </div>
  );
}

